import _ from "lodash";

import { ArrowDropDownIcon, ArrowRightIcon } from "icons";

import Stack from "components/Stack";
import Text from "components/Text";

const CellTitle = ({
  cellDataTestId,
  setCollapsedSubCategories,
  isTotalRow,
  collapsedSubCategories,
  label,
  isBold,
  isCalculationItem,
}: {
  cellDataTestId: string;
  setCollapsedSubCategories: React.Dispatch<
    React.SetStateAction<Array<string>>
  >;
  isTotalRow: boolean;
  collapsedSubCategories: Array<string>;
  label: string;
  isBold: boolean;
  isCalculationItem: boolean;
}) => (
  <Stack
    data-testid={cellDataTestId}
    onClick={() => {
      setCollapsedSubCategories((current) => _.xor(current, [label]));
    }}
    direction="row"
    sx={{
      alignItems: "center",
      width: "100%",
      flex: 1,
      cursor: isTotalRow ? "pointer" : "inherit",
      overflow: "hidden",
      gap: 0.5,
    }}
  >
    {!isTotalRow && !isCalculationItem && <span style={{ width: "24px" }} />}
    {isTotalRow &&
      (collapsedSubCategories.indexOf(label) === -1 ? (
        <ArrowDropDownIcon sx={{ width: "16px", height: "16px" }} />
      ) : (
        <ArrowRightIcon sx={{ width: "16px", height: "16px" }} />
      ))}
    <Text
      variant="text3"
      sx={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        fontWeight: isTotalRow || isBold || isCalculationItem ? 700 : 400,
      }}
      data-testid="title-name-value"
    >
      {label}
    </Text>
  </Stack>
);

export default CellTitle;
